<template>
  <v-row class="text-center" justify="space-around" height='90vh' style="margin: 0 0">
    <v-col cols='2'>
      <h1>Player Health</h1>
      <v-progress-circular
        :rotate="-90"
        :size="100"
        :width="15"
        :value="health"
        color="blue"
      >
        {{health}}
      </v-progress-circular>
      <h4 v-if='round > 0'>{{enemyHitText}}</h4>
      <v-img :src='activeCardGif' contain></v-img>
    </v-col>
    <v-col cols='8'>
      <v-row class="text-center" justify="space-around" height='90vh' style="margin: 0 0">
        <v-col cols='4'>
          <v-icon color='blue'>mdi-shield</v-icon>
          {{def}}
        </v-col>
        <v-col cols='4'>
          <v-icon color='red'>mdi-sword</v-icon>
          {{attack}}
        </v-col>
        <v-col cols='4'>
          <v-icon color='green'>mdi-cash-plus</v-icon>
          {{costPoints}}
        </v-col>
        <v-col cols='12'>
          <v-btn text color='red' @click='playTurn()'>End Turn</v-btn>
        </v-col>
      </v-row>
      <v-row class="text-center" justify="start" height='90vh' style="margin: 0 0">
        <v-col cols="3" v-for="card in hand">
          <v-hover v-slot:default="{ hover }">
            <v-card :color='card.color' @click="checkPlay(card)">
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-icon color='green'>mdi-cash-minus</v-icon>
                {{card.cost}}
              </v-card-actions>
              <v-img
                :src="card.src"
                class="white--text align-end"
                gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                height="300px"
              >
                <v-expand-transition>
                  <div
                    v-if="hover"
                    class="d-flex transition-fast-in-fast-out darken-2 v-card--reveal subtitle-4 white--text"
                    style="height: 100%;"
                  >
                    {{card.desc}}
                  </div>
                </v-expand-transition>
                <v-card-title v-text="card.title"></v-card-title>
              </v-img>
              <v-card-actions>
                <v-spacer></v-spacer>
                <div v-if="!!card.modifiers[0]">
                  <v-icon color='orange'>mdi-cards</v-icon>
                  {{card.modifiers[0]}}
                </div>
                <div v-if="!!card.modifiers[1]">
                  <v-icon color='blue'>mdi-shield</v-icon>
                  {{card.modifiers[1]}}
                </div>
                <div v-if="!!card.modifiers[2]">
                  <v-icon color='red'>mdi-sword</v-icon>
                  {{card.modifiers[2]}}
                </div>
                <div v-if="!!card.modifiers[3]">
                  <v-icon color='green'>mdi-cash-plus</v-icon>
                  {{card.modifiers[3]}}
                </div>
              </v-card-actions>
            </v-card>
          </v-hover>
        </v-col>
        <v-snackbar
        v-model="costPointsTooLow"
        timeout="2000"
        >
          Cost Points Too Low!
          <template v-slot:action="{ attrs }">
            <v-btn
              color="blue"
              text
              v-bind="attrs"
              @click="costPointsTooLow = false"
            >
              Close
            </v-btn>
          </template>
        </v-snackbar>
        <v-snackbar
        v-model="handFull"
        timeout="2000"
        >
          Your hand is too full to play this card!
          <template v-slot:action="{ attrs }">
            <v-btn
              color="blue"
              text
              v-bind="attrs"
              @click="handFull = false"
            >
              Close
            </v-btn>
          </template>
        </v-snackbar>
      </v-row>
    </v-col>
    <v-col cols='2'>
      <h1>Enemy Health</h1>
      <v-progress-circular
        :rotate="-90"
        :size="100"
        :width="15"
        :value="enemyHealth"
        color="red"
      >
        {{enemyHealth}}
      </v-progress-circular>
      <h4 v-if='round > 0'>{{playerHitText}}</h4>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: 'battleCardsPlay',
    data: () => ({
      health: 100,
      enemyHealth: 100,
      hand: [],
      attack: 0,
      def: 0,
      costPoints: 1,
      permanentAttack: 0,
      permanentDef: 0,
      costPointsTooLow: false,
      handFull: false,
      roundPlayedCards: [],
      enemyAttack: 0,
      enemyFinalAttack: 0,
      enemyHitText: '',
      playerHitText: '',
      round: 0,
      activeCardGif: '',
      win: false,
      lose: false,
    }),
    computed: {
      activeBattleCardsDeck () {
        return this.$store.state.activeBattleCardsDeck;
      }
    },
    methods:{
      checkPlay(card){
        if(card.cost > this.costPoints){
          this.costPointsTooLow = true;
          return;
        }
        this.roundPlayedCards.push(card);
        if(card.modifiers[0] != 0){
          if(((this.hand.length - 1) + card.modifiers[0]) > 4){
            this.handFull = true;
            return;
          } else {
            this.playDraw(card.modifiers[0]);
          }
        }
        this.playCard(card);
      },
      playCard(card){
        this.costPoints -= card.cost;
        if(card.desc.includes("Permanently")){
          this.permanentDef += card.modifiers[1];
          this.permanentAttack += card.modifiers[2];
        }
        this.def += card.modifiers[1];
        this.attack += card.modifiers[2];
        this.costPoints += card.modifiers[3];
        this.hand = this.hand.filter(handCard => {
          return handCard.id != card.id;
        });
        this.roundPlayedCards.push(card);
        this.activeCardGif = card.gifs[Math.floor(Math.random() * card.gifs.length)];
      },
      playDraw(drawNum){
        let endHandNum = (this.hand.length) + drawNum;
        while(this.hand.length < endHandNum){
          let drawnCard = this.activeBattleCardsDeck[Math.floor(Math.random()*this.activeBattleCardsDeck.length)];
          if(!this.hand.includes(drawnCard) && !this.roundPlayedCards.includes(drawnCard)){
            this.hand.push(drawnCard);
          }
        }
      },
      playTurn(){
        this.enemyHealth -= this.attack;
        this.enemyAttack = Math.floor(Math.random() * 5) + 1;
        let enemyAttackFinal = this.enemyAttack;
        if(enemyAttackFinal - this.def < 0){
          enemyAttackFinal = 0;
        } else {
          enemyAttackFinal = enemyAttackFinal - this.def;
        }
        this.enemyHitText = 'Enemy hit for ' + enemyAttackFinal + ' (' + this.enemyAttack + ' - ' + this.def + ')';
        this.playerHitText = 'You hit for ' + this.attack;
        this.enemyFinalAttack = enemyAttackFinal;
        this.health -= enemyAttackFinal;
        this.roundPlayedCards = [];
        this.hand = [];
        while(this.hand.length < 4){
          let drawnCard = this.activeBattleCardsDeck[Math.floor(Math.random()*this.activeBattleCardsDeck.length)];
          if(!this.hand.includes(drawnCard)){
            this.hand.push(drawnCard);
          }
        }
        this.costPoints++;
        this.def = this.permanentDef;
        this.attack = this.permanentAttack;
        this.round++;
        if(this.enemyHealth <= 0){
          this.enemyHealth = 0;
          this.win = true;
          this.$store.dispatch('calculateWinPoints', this.round);
        }
        if(this.health <= 0){
          this.health = 0;
          this.lose = true;
        }
      }
    },
    mounted(){
      this.health = 100;
      this.enemyHealth = 100;
      this.hand = [];
      this.attack = 0;
      this.def = 0;
      this.costPoints = 1;
      this.costPointsTooLow = false;
      this.handFull = false;
      this.roundPlayedCards = [];
      this.enemyAttack = 0;
      this.enemyFinalAttack = 0;
      this.enemyHitText = '';
      this.playerHitText = '';
      this.round = 0;
      this.activeCardGif = '';
      this.win = false;
      this.lose = false;
      while(this.hand.length < 4){
        let drawnCard = this.activeBattleCardsDeck[Math.floor(Math.random()*this.activeBattleCardsDeck.length)];
        if(!this.hand.includes(drawnCard)){
          this.hand.push(drawnCard);
        }
      }
    }
  }
</script>